module.exports = __webpack_public_path__ + "static/logo-9a4114e5daa4132443af5d89a68a2bf8.svg";